import type { ModelPropertyValueType } from '@fulcrum/cdm-components';
import { PropertyType } from '@technology/web3d-plugin-trimbim';

// Numeric codes aligned with CDM's ModelPropertyValueType const enum.
const MODEL_PROPERTY_VALUE_TYPE_CODES = {
  LENGTH: 0,
  AREA: 1,
  VOLUME: 2,
  MASS: 3,
  ANGLE: 4,
  STRING: 5,
  INTEGER: 6,
  DOUBLE: 7,
  DATE_TIME: 8,
  ENUM: 9,
  BOOLEAN: 10,
} as const;

type ModelPropertyValueTypeCode =
  (typeof MODEL_PROPERTY_VALUE_TYPE_CODES)[keyof typeof MODEL_PROPERTY_VALUE_TYPE_CODES];

export const MODEL_PROPERTY_TYPE: Readonly<
  Record<number, ModelPropertyValueTypeCode>
> = {
  [PropertyType.LengthMeasure]: MODEL_PROPERTY_VALUE_TYPE_CODES.LENGTH,
  [PropertyType.AreaMeasure]: MODEL_PROPERTY_VALUE_TYPE_CODES.AREA,
  [PropertyType.VolumeMeasure]: MODEL_PROPERTY_VALUE_TYPE_CODES.VOLUME,
  [PropertyType.MassMeasure]: MODEL_PROPERTY_VALUE_TYPE_CODES.MASS,
  [PropertyType.AngleMeasure]: MODEL_PROPERTY_VALUE_TYPE_CODES.ANGLE,
  [PropertyType.StringValue]: MODEL_PROPERTY_VALUE_TYPE_CODES.STRING,
  [PropertyType.IntValue]: MODEL_PROPERTY_VALUE_TYPE_CODES.INTEGER,
  [PropertyType.DoubleValue]: MODEL_PROPERTY_VALUE_TYPE_CODES.DOUBLE,
  [PropertyType.DateTime]: MODEL_PROPERTY_VALUE_TYPE_CODES.DATE_TIME,
  [PropertyType.Logical]: MODEL_PROPERTY_VALUE_TYPE_CODES.ENUM,
  [PropertyType.Boolean]: MODEL_PROPERTY_VALUE_TYPE_CODES.BOOLEAN,
};

export function toModelPropertyValueType(type: number): ModelPropertyValueType {
  const mappedType = MODEL_PROPERTY_TYPE[type];
  if (mappedType === undefined) {
    throw new Error(`Unsupported PropertyType value: ${type}`);
  }

  return mappedType;
}
